module.exports = __webpack_public_path__ + "static/img/guanwang22.b08fd177.png";